var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAgent = function SvgAgent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "CurrentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5.333A2.667 2.667 0 1 0 4 0a2.667 2.667 0 0 0 0 5.333ZM4 .667a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.834 6.697a2.133 2.133 0 1 0 0-4.266 2.133 2.133 0 0 0 0 4.266Zm0-3.606a1.467 1.467 0 1 1 0 2.933 1.467 1.467 0 0 1 0-2.933Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.667 7.212H8a2.358 2.358 0 0 0-.282.033A2.327 2.327 0 0 0 5.667 6H2.333A2.333 2.333 0 0 0 0 8.333v3.334A.333.333 0 0 0 .333 12h11.334a.333.333 0 0 0 .333-.333V9.545a2.333 2.333 0 0 0-2.333-2.333Zm-9 1.121a1.667 1.667 0 0 1 1.666-1.666h3.334a1.667 1.667 0 0 1 1.666 1.666v3H.667v-3Zm10.666 3H8v-3c0-.15-.016-.301-.045-.449.015 0 .03-.005.045-.005h1.667a1.667 1.667 0 0 1 1.666 1.666v1.788Z"
  }))));
};
export default SvgAgent;